import request from '@/utils/request'

const url = 'dapi/nhw/alarm'

export function getList(params) {
  return request({
    url: url+'/list',
    method: 'get',
    params
  })
}

export function deleteRows(data) {
  return request({
    url: url,
    method: 'delete',
    data
  })
}

export function saveRow(data) {
  return request({
    url: url,
    method: data.alarmId ? 'put' : 'post',
    data
  })
}
